import { Button } from "./ui/button";
import { ArrowRight, Play } from "lucide-react";
import { ImageWithFallback } from "./figma/ImageWithFallback";

export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 pb-16 pt-24 md:pb-24 md:pt-32">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-900/20 via-transparent to-emerald-900/20"></div>
      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 md:grid-cols-2">
          <div className="space-y-6">
            <div className="inline-block rounded-full border border-blue-500/20 bg-blue-500/10 px-4 py-2 text-blue-400">
              GoHighLevel • Business Automation • Local LLM
            </div>
            <h1 className="text-white">
              Seamless Systems Integration & Automation
            </h1>
            <p className="text-gray-400">
              We connect your disparate systems, automate workflows, and unlock
              the full potential of your technology stack. Increase efficiency,
              reduce costs, and scale your operations with confidence.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button
                onClick={() => scrollToSection("contact")}
                className="flex min-w-[220px] items-center justify-center bg-gradient-to-r from-blue-500 to-emerald-500 text-white hover:from-blue-600 hover:to-emerald-600"
              >
                <span className="border-b border-white/30 pb-0.5">
                  Contact Us
                </span>
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button
                onClick={() => scrollToSection("services")}
                className="flex min-w-[220px] items-center justify-center bg-gradient-to-r from-blue-500 to-emerald-500 text-white hover:from-blue-600 hover:to-emerald-600"
              >
                <Play className="mr-2 h-4 w-4" />
                <span className="border-b border-white/30 pb-0.5">
                  Our Offers
                </span>
              </Button>
            </div>
            <div className="h-px w-full bg-gradient-to-r from-transparent via-blue-500/50 to-transparent"></div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 rotate-3 transform rounded-2xl bg-gradient-to-tr from-blue-600 to-emerald-500 opacity-50 blur-xl"></div>
            <ImageWithFallback
              src="https://images.unsplash.com/photo-1753715613388-7e03410b1dce?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3b3JrZmxvdyUyMGRpYWdyYW0lMjBhcmNoaXRlY3R1cmV8ZW58MXx8fHwxNzYzOTExNjAxfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
              alt="Workflow automation architecture diagram"
              className="relative h-auto w-full rounded-2xl shadow-2xl ring-1 ring-blue-500/20"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
